import { addProp, differenceWith, map, pipe } from 'remeda';

import type { UpdateAutomationVariables } from '../../../api/use-update-automation';

export function markForDestroy(
  initialValues: UpdateAutomationVariables,
  currentValues: UpdateAutomationVariables,
): UpdateAutomationVariables {
  const removedConditions = pipe(
    initialValues.conditions,
    differenceWith(currentValues.conditions, (a, b) => a.id === b.id),
    map(addProp('_destroy', true as true)),
  );

  const removedActions = pipe(
    initialValues.actions,
    differenceWith(currentValues.actions, (a, b) => a.id === b.id),
    map(v => ({ ...v, _destroy: true })),
  );

  return {
    ...currentValues,
    conditions: [...currentValues.conditions, ...removedConditions],
    actions: [...currentValues.actions, ...removedActions],
  };
}
